import  { Header as SourceHeader }  from 'SourceComponent/Header/Header.component';
import CmsBlock from 'SourceComponent/CmsBlock';
import Link from 'SourceComponent/Link';
import ChevronIcon from 'Component/ChevronIcon';
import { LEFT } from 'Component/ChevronIcon/ChevronIcon.config';
import media, { WYSIWYG_MEDIA } from "Util/Media/Media";
import StoreSwitcher from 'Component/StoreSwitcher';
import ClickOutside from 'Component/ClickOutside';
import OfflineNotice from 'Component/OfflineNotice';
import CurrencySwitcher from 'Component/CurrencySwitcher';
import SearchField from 'Component/SearchField';
import { isSignedIn } from 'Util/Auth';
import { TotalsType } from 'Type/MiniCart';
import { DeviceType } from 'Type/Device';
import { isCrawler, isSSR } from 'Util/Browser';
import { DEFAULT_STATE_NAME } from 'Component/NavigationAbstract/NavigationAbstract.config';
import { appendWithStoreCode } from 'Util/Url';
import {
    CART,
    CART_EDITING,
    CART_OVERLAY,
    CATEGORY,
    CHECKOUT,
    CHECKOUT_ACCOUNT,
    CHECKOUT_SUCCESS,
    CMS_PAGE,
    CONTACT_US,
    CUSTOMER_ACCOUNT,
    CUSTOMER_ACCOUNT_PAGE,
    CUSTOMER_SUB_ACCOUNT,
    CUSTOMER_WISHLIST,
    FILTER,
    MENU,
    MENU_SUBCATEGORY,
    NO_MATCH,
    PDP,
    POPUP,
    PRODUCT_COMPARE,
    SEARCH
} from "SourceComponent/Header/Header.config";
import $ from 'jquery';
// COMMENT OUT BEFORE COMMIT
import { findbarEnglishScript, findbarScript } from "../../../public/assets/js/findbar";
import { generalScripts } from "../../../public/assets/js/general-scripts";
import { lazy, Suspense } from "react";
import history from 'SourceUtil/History';
import PropTypes from "prop-types";
export const Menu = lazy(() => import(/* webpackMode: "lazy", webpackChunkName: "menu" */ 'Component/Menu'));
export const CartOverlay = lazy(() => import(/* webpackMode: "lazy", webpackChunkName: "overlay" */ 'Component/CartOverlay'));
export const UniversalIcon = lazy(() => import(/* webpackMode: "lazy", webpackChunkName: "icons" */ 'Component/UniversalIcon'));

/** @namespace Component/Header/Component */
export class Header extends SourceHeader {
    static propTypes = {
        navigationState: PropTypes.object.isRequired,
        cartTotals: TotalsType.isRequired,
        onBackButtonClick: PropTypes.func.isRequired,
        onCloseButtonClick: PropTypes.func.isRequired,
        onSearchBarFocus: PropTypes.func.isRequired,
        onClearSearchButtonClick: PropTypes.func.isRequired,
        onMyAccountButtonClick: PropTypes.func.isRequired,
        onSearchBarChange: PropTypes.func.isRequired,
        isWishlistLoading: PropTypes.bool.isRequired,
        onEditButtonClick: PropTypes.func.isRequired,
        onMinicartButtonClick: PropTypes.func.isRequired,
        onOkButtonClick: PropTypes.func.isRequired,
        onCancelButtonClick: PropTypes.func.isRequired,
        onSearchOutsideClick: PropTypes.func.isRequired,
        onMyAccountOutsideClick: PropTypes.func.isRequired,
        onMinicartOutsideClick: PropTypes.func.isRequired,
        isClearEnabled: PropTypes.bool.isRequired,
        searchCriteria: PropTypes.string.isRequired,
        shareWishlist: PropTypes.func.isRequired,
        onMyWishlistButtonClick: PropTypes.func.isRequired,
        header_logo_src: PropTypes.string,
        logo_alt: PropTypes.string,
        logo_height: PropTypes.number,
        logo_width: PropTypes.number,
        updateHeaderScrollTop: PropTypes.func.isRequired,
        updateHeaderHeight: PropTypes.func.isRequired,
        window_height_except_header: PropTypes.number,
        header_scroll_top: PropTypes.number,
        isLoading: PropTypes.bool,
        showMyAccountLogin: PropTypes.bool,
        isCheckout: PropTypes.bool.isRequired,
        onSignIn: PropTypes.func.isRequired,
        hideActiveOverlay: PropTypes.func.isRequired,
        device: DeviceType.isRequired
    };

    static defaultProps = {
        logo_alt: 'ScandiPWA logo',
        logo_height: 25,
        logo_width: 200,
        showMyAccountLogin: false,
        header_logo_src: '',
        isLoading: true,
        header_bg: '#ffffff',
        header_fc: '#000000',
        header_inverse_icons: false
    };

    stateMap = {
        [DEFAULT_STATE_NAME]: {
            title: true,
            logo: true
        },
        [NO_MATCH]: {
            title: true
        },
        [POPUP]: {
            title: true,
            close: true
        },
        [PDP]: {
            back: false,
            title: true
        },
        [CATEGORY]: {
            title: true
        },
        [CUSTOMER_ACCOUNT]: {
            title: true
        },
        [CUSTOMER_SUB_ACCOUNT]: {
            title: true,
            back: true
        },
        [CUSTOMER_ACCOUNT_PAGE]: {
            title: true
        },
        [CUSTOMER_WISHLIST]: {
            share: true,
            title: true,
            ok: true
        },
        [MENU]: {

        },
        [MENU_SUBCATEGORY]: {
            back: true,
            title: true,
        },
        [SEARCH]: {
            search: true
        },
        [CART]: {
            title: true
        },
        [CART_OVERLAY]: {
            title: true
        },
        [CART_EDITING]: {
            ok: true,
            title: true,
            cancel: true
        },
        [FILTER]: {
            close: true,
            title: true
        },
        [CHECKOUT]: {
            back: true,
            title: true,
            account: true
        },
        [CHECKOUT_SUCCESS]: {
            title: true,
            account: true
        },
        [CHECKOUT_ACCOUNT]: {
            title: true,
            close: true
        },
        [CMS_PAGE]: {
            menu: true,
            title: true
        },
        [CONTACT_US]: {
            title: true,
            back: true
        },
        [PRODUCT_COMPARE]: {
            title: true,
            back: true
        }
    };

    renderMap = {
        cancel: this.renderCancelButton.bind(this),
        // back: this.renderBackButton.bind(this),
        close: this.renderCloseButton.bind(this),
        langswitcher: this.renderLangSwitcher.bind(this),
        logo: this.renderLogo.bind(this),
        search: this.renderSearchField.bind(this),
        account: this.renderAccount.bind(this),
        // compare: this.renderComparePageButton.bind(this),
        share: this.renderShareWishListButton.bind(this),
        minicart: this.renderMinicart.bind(this),
        ok: this.renderOkButton.bind(this)
    };

    componentDidMount() {
        const { store } = this.props;
        if (typeof $ === "function") {
            generalScripts();
        } else {
            setTimeout(generalScripts, 2000);
        }
        this.updateHeaderStyle();
        window.addEventListener('scroll', () => {
            this.updateScrollHeaderStyle();
        });
        // COMMENT OUT BEFORE COMMIT
        if (store === 'el') {
            findbarScript();
        }
        if (store !== 'el') {
            findbarEnglishScript();
        }
    }

    componentDidUpdate(prevProps) {
        const { store } = this.props;
        const { store: prevStore } = prevProps;
        this.updateHeaderStyle();

        if (store !== prevStore) {
            if (store === 'el') {
                return findbarScript();
            }
            return findbarEnglishScript();
        }
    }

    updateScrollHeaderStyle() {
        const { updateHeaderScrollTop } = this.props;
        let header = document.getElementById('Header');
        let navigationTabs = document.getElementById('NavigationTabs');
        let headerSlogan = document.getElementById('HeaderSlogan');
        let headerTopMenu = document.getElementById('Header-TopMenu');
        let HeaderHeight = 0;
        let headerSloganHeight = 0;
        let headerTopMenuHeight = 0;

        if(headerSlogan) {
            headerSloganHeight = headerSlogan.clientHeight;
        }

        if(headerTopMenu) {
            headerTopMenuHeight = headerTopMenu.clientHeight;
        }

        if(header) {
            HeaderHeight = header.clientHeight;
        }

        if(window.scrollY > HeaderHeight) {
            header.style.marginTop = '-' + (headerSloganHeight + headerTopMenuHeight) + 'px';
            updateHeaderScrollTop(headerSloganHeight + headerTopMenuHeight);

            if(navigationTabs && window.innerWidth < 811) {
                navigationTabs.style.marginTop = '-' + (headerSloganHeight + headerTopMenuHeight) + 'px';
                updateHeaderScrollTop(headerSloganHeight + headerTopMenuHeight);
            }
        } else {
            if(header.style) {
                header.style.marginTop = '0px';
                updateHeaderScrollTop(0);
            }

            if(navigationTabs && window.innerWidth < 811) {
                navigationTabs.style.marginTop = '0px';
                updateHeaderScrollTop(0)
            }
        }
    }

    updateHeaderStyle() {
        const { updateHeaderHeight } = this.props;
        let headerArea = document.getElementById('Header-Wrapper');
        let navigationTabs = document.getElementById('NavigationTabs');
        let header = document.getElementById('Header');

        if(header && headerArea){
            setTimeout(function(){
                let HeaderHeight = header.clientHeight;
                headerArea.style.paddingTop = '0px';
                headerArea.style.marginBottom = HeaderHeight + 'px';
                updateHeaderHeight(window.screen.height - HeaderHeight - 150);
            }, 1000);
        }

        if(header && headerArea && navigationTabs && window.innerWidth < 811){
            setTimeout(function(){
                let HeaderHeight = header.clientHeight;
                headerArea.style.marginBottom = '0px';
                headerArea.style.paddingTop = HeaderHeight + 'px';
                navigationTabs.style.top = HeaderHeight + 'px';
                updateHeaderHeight(window.screen.height - HeaderHeight - 150);
            }, 1000);
        }
    }

    renderSearchField(isVisible = false) {
        const {
            searchCriteria,
            onSearchOutsideClick,
            onSearchBarFocus,
            onSearchBarChange,
            onClearSearchButtonClick,
            navigationState: { name },
            isCheckout,
            hideActiveOverlay,
            header_inverse_icons
        } = this.props;

        if (isCheckout) {
            return null;
        }

        return (
            <SearchField
                key="search"
                searchCriteria={ searchCriteria }
                onSearchOutsideClick={ onSearchOutsideClick }
                onSearchBarFocus={ onSearchBarFocus }
                onSearchBarChange={ onSearchBarChange }
                onClearSearchButtonClick={ onClearSearchButtonClick }
                isVisible={ isVisible }
                isActive={ name === SEARCH }
                hideActiveOverlay={ hideActiveOverlay }
                headerInverseIcons={ header_inverse_icons }
            />
        );
    }

    renderAccount(isVisible = false) {
        const {
            onMyAccountOutsideClick,
            isCheckout,
            device: { isMobile }
        } = this.props;

        // on mobile hide button if not in checkout
        if (isMobile && !isCheckout) {
            return null;
        }

        if (isCheckout && isSignedIn()) {
            return null;
        }

        return (
            <div key="account" block="Header" elem="MyAccountContainer">
                <ClickOutside
                    onClick={ onMyAccountOutsideClick }
                >
                    <div
                        aria-label="My account"
                        block="Header"
                        elem="MyAccount"
                    >
                        { this.renderAccountButton(isVisible) }
                        { this.renderAccountOverlay() }
                    </div>
                </ClickOutside>
            </div>
        );
    }

    renderMinicartOverlay() {
        const { shouldRenderCartOverlay, navigationState: { name }, navigationState, onMinicartOutsideClick } = this.props;

        if (!shouldRenderCartOverlay && name !== CART_OVERLAY) {
            return null;
        }

        return (
            <Suspense fallback={ this.renderMinicartOverlayFallback() }>
                <CartOverlay onMinicartOutsideClick={onMinicartOutsideClick} />
            </Suspense>
        );
    }

    renderLogo(isVisible = false) {
        const { isFashion, onClickLogo } = this.props;

        const url = isFashion ? appendWithStoreCode('/home_fashion') : appendWithStoreCode('/');

        return (
            <Link
                to={ url }
                aria-label="Go to homepage by clicking on ScandiPWA logo"
                aria-hidden={ !isVisible }
                tabIndex={ isVisible ? 0 : -1 }
                block="Header"
                elem="LogoWrapper"
                mods={ { isVisible } }
                key="logo"
                onClick= { onClickLogo }
            >
                {/*{ this.renderLogoImage() }*/}
                <div className="Image_imageStatus Logo">
                    <UniversalIcon
                        src={media('logo.svg', WYSIWYG_MEDIA)}
                        alt="logo"
                        className="Image-Image"
                    />
                </div>
            </Link>
        );
    }

    renderAccountButton() {
        const {
            onMyAccountButtonClick,
            device,
            header_inverse_icons
        } = this.props;

        if (device.isMobile) {
            return null;
        }

        const isGuest = !isSignedIn();
        const navigateToguestWishlisl = () => history.push({ pathname: appendWithStoreCode('/guestwishlist') })

        if(!isGuest) {
            return (
                <button
                    block="Header"
                    elem="MyAccountWrapper"
                    tabIndex="0"
                    onClick={ onMyAccountButtonClick }
                    aria-label="Open my account"
                    id="myAccount"
                >
                    <UniversalIcon
                        src={media(header_inverse_icons ? 'account_white.svg' : 'account.svg', WYSIWYG_MEDIA)}
                        alt="accountIcon"
                        className="UserIcon"
                    />
                </button>
            );
        }

        return (
            <>
                <button
                    rel='nofollow'
                    block="Header"
                    elem="MyAccountWrapper"
                    tabIndex="0"
                    onClick={ onMyAccountButtonClick }
                    aria-label="Open my account"
                    id="myAccount"
                >
                    <UniversalIcon
                        src={media(header_inverse_icons ? 'account_white.svg' : 'account.svg', WYSIWYG_MEDIA)}
                        alt="accountIcon"
                        className="UserIcon"
                    />
                </button>
                <button
                    rel='nofollow'
                    block="Header"
                    elem="Button"
                    mods={ { type: 'wishlist' } }
                    tabIndex="0"
                    onClick={ isGuest ? navigateToguestWishlisl : onMyAccountButtonClick }
                    aria-label={ __('wishlist Page') }
                    id="myAccount"
                >
                    <UniversalIcon
                        src={media(header_inverse_icons ? 'wishlist_new_white.svg' : 'wishlist_new.svg', WYSIWYG_MEDIA)}
                        alt="WishlistIcon"
                        className="WishlistIcon"
                    />
                </button>
            </>
        );
    }

    renderShareWishListButton() {
        const { onMyWishlistButtonClick, device: { isMobile }, header_inverse_icons } = this.props;

        if (isMobile) {
            return null;
        }

        if(isSignedIn()) {
            return (
                <Link
                    to={ 'my-account/my-wishlist' }
                    key="wishlist"
                    block="Header"
                    elem="Button"
                    mods={ { type: 'wishlist' } }
                    aria-label={ __('wishlist Page') }
                >
                    <UniversalIcon
                        src={media(header_inverse_icons ? 'wishlist_new_white.svg' : 'wishlist_new.svg', WYSIWYG_MEDIA)}
                        alt="WishlistIcon"
                        className="WishlistIcon"
                    />
                </Link>
            );
        }

        return null
    }

    renderLangSwitcher() {
        const { device: { isMobile }, header_inverse_icons } = this.props;

        if (isMobile) {
            return (
                <Link to={ '/hondos-center-stores' } block="Header" elem="LangSwitchLink">
                    <UniversalIcon
                        src={media(header_inverse_icons ? 'store-white.png' : 'store-black.png', WYSIWYG_MEDIA)}
                        alt="pinIcon"
                    />
                </Link>
            );
        }

        return (
            <>
                <Link to={ '/hondos-center-stores' } block="Header" elem="LangSwitchLink">
                    <UniversalIcon
                        src={media(header_inverse_icons ? 'store-white.png' : 'store-black.png', WYSIWYG_MEDIA)}
                        alt="pinIcon"
                    />
                    { __('Καταστήματα') }
                </Link>
                <div block="Header" elem="Switcher">
                    <CurrencySwitcher />
                    <StoreSwitcher />
                </div>
            </>
        );
    }

    renderMinicartButton() {
        const {
            onMinicartButtonClick,
            header_inverse_icons
        } = this.props;

        return (
            <button
                block="Header"
                elem="MinicartButtonWrapper"
                tabIndex="0"
                onClick={ onMinicartButtonClick }
                aria-label={ __('Cart') }
            >
                <UniversalIcon
                    src={media(header_inverse_icons ? 'cart_white.svg' : 'cart.svg', WYSIWYG_MEDIA)}
                    alt="cartIcon"
                    className="CartIcon"
                />
                { this.renderMinicartItemsQty() }
            </button>
        );
    }

    renderMenu() {
        const { isCheckout, device: { isMobile } } = this.props;

        if (isMobile || isCheckout) {
            return null;
        }

        return <Menu isHeader />;
    }


    renderTopMenu() {
        const { device: { isMobile }, blocks: { items }, blocks, cmsBlockidentifier } = this.props;
        const cmsBlock = items[cmsBlockidentifier] ? items[cmsBlockidentifier] : {};

        // if (isMobile) {
        //     return (
        //         <>
        //             <CmsBlock isVisible={true} noWrapper={true} isHeader cmsBlock={cmsBlock} />
        //             {this.renderWebsiteSwitch()}
        //         </>
        //     );
        // }

        return (
            <>
                <CmsBlock isVisible={true} noWrapper={true} isHeader cmsBlock={cmsBlock} />
                {this.renderWebsiteSwitch()}
            </>
        );
    }

    switchWebsite = (isFashion) => {
        const { switchWebsite, isFashion: activeState } = this.props;

        if (activeState === isFashion) {
            return null
        }
        switchWebsite(isFashion);

    }

    renderWebsiteSwitch() {
        const { isFashion } = this.props;

        return (
            <div className="Header-WebsiteSwitch">
                <div className="Header-WebsiteSwitchColumn" >
                    <Link 
                     block="Header" 
                     elem="WebsiteSwitchLink" 
                     mods={ { isActive: !isFashion} }
                     to= { appendWithStoreCode('/') }
                     onClick={ () => this.switchWebsite(false) } ><span>{ __('BEAUTY') }</span></Link>
                </div>
                <div className="Header-WebsiteSwitchColumn" >
                    <Link  
                      block="Header" 
                      elem="WebsiteSwitchLink" 
                      mods={ {isActive: isFashion }}
                      to= { appendWithStoreCode('/home_fashion') }
                      onClick={ () => this.switchWebsite(true) } ><span>{ __('FASHION') }</span></Link>
                </div>
            </div>
        );
    }

    render() {
        const { stateMap } = this;
        const {
            navigationState: { name, isHiddenOnMobile = false },
            isCheckout,
            device: { isMobile },
            window_height_except_header,
            header_scroll_top,
            header_bg,
            header_fc
        } = this.props;

        const style = {
            '--window-height-except-header': (parseFloat(window_height_except_header)+parseFloat(header_scroll_top))+'px',
            '--header-scroll-top': header_scroll_top+'px',
            '--header-bg': header_bg,
            '--header-fc': header_fc
        };

        if (!isMobile) {
            // hide edit button on desktop
            stateMap[CUSTOMER_WISHLIST].edit = false;
            stateMap[CUSTOMER_WISHLIST].share = false;
            stateMap[CART_OVERLAY].edit = false;
        }

        if(isCheckout) {
            return (
                <section
                    block="Header"
                    elem="Wrapper"
                    mods={ { isPrerendered: isSSR() || isCrawler() } }
                    id="Header-Wrapper"
                    style={ style }
                >
                    <header
                        block="Header"
                        mods={ { name, isHiddenOnMobile, isCheckout } }
                        mix={ { block: 'FixedElement', elem: 'Top' } }
                        ref={ this.logoRef }
                        id="Header"
                    >
                        <nav block="Header" elem="Nav">
                            { this.renderLogo(true) }
                        </nav>
                    </header>
                    <OfflineNotice />
                </section>
            );
        }

        return (
            <section
                block="Header"
                elem="Wrapper"
                mods={ { name, isPrerendered: isSSR() || isCrawler() } }
                id="Header-Wrapper"
                style={ style }
            >
                <header
                    block="Header"
                    mods={ { name, isHiddenOnMobile, isCheckout } }
                    mix={ { block: 'FixedElement', elem: 'Top' } }
                    ref={ this.logoRef }
                    id="Header"
                >
                    { this.renderTopMenu() }
                    <nav block="Header" elem="Nav">
                        { this.renderNavigationState() }
                    </nav>
                    { this.renderMenu() }
                </header>
                <OfflineNotice />
            </section>
        );
    }

}

export default Header;
